import { CredentialsDto } from './user.types';
import { handleQueryAuthCredentials } from './helpers';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@shared/api/baseApi';

export const userApi = createApi({
  baseQuery,
  reducerPath: 'userApi',
  endpoints: build => ({
    auth: build.query<string, string>({
      query: accessToken => ({
        url: '/users/auth',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) =>
        await handleQueryAuthCredentials(dispatch, queryFulfilled),
    }),
    refresh: build.mutation<string, Omit<CredentialsDto, 'accessToken'>>({
      query: refreshBody => ({
        url: '/users/auth/refresh-token',
        method: 'POST',
        body: refreshBody,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) =>
        await handleQueryAuthCredentials(dispatch, queryFulfilled),
    }),
    googleAuth: build.query<string, string>({
      query: googleTokenResponse => ({
        url: '/users/auth/google-auth',
        headers: {
          Authorization: `Bearer ${googleTokenResponse}`,
        },
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) =>
        await handleQueryAuthCredentials(dispatch, queryFulfilled),
    }),
  }),
});

export const { useLazyAuthQuery, useLazyGoogleAuthQuery, useRefreshMutation } = userApi;
